var map = {
	"./backpack.png": 52920,
	"./binance.png": 57998,
	"./binancew3w.png": 96493,
	"./bitcoin.png": 90554,
	"./bitget.png": 68529,
	"./coin98.png": 92994,
	"./coinbase.png": 26142,
	"./elli.png": 31100,
	"./ethos.png": 50511,
	"./foxwallet.png": 52008,
	"./frontier.png": 11729,
	"./fuel.png": 93706,
	"./fuelet.png": 65661,
	"./glass.png": 65604,
	"./imToken.png": 16581,
	"./leather.png": 94371,
	"./martian.png": 61528,
	"./metaMask.png": 10037,
	"./morphis.png": 6574,
	"./nightly.png": 88387,
	"./okx.png": 60674,
	"./oneKey.png": 59047,
	"./phantom.png": 43027,
	"./rabby.png": 55300,
	"./rainbow.png": 2282,
	"./safepal.png": 1962,
	"./sensui.png": 30361,
	"./solana.png": 40110,
	"./spacecy.png": 96090,
	"./starknet.png": 56314,
	"./sui.png": 14313,
	"./suiet.png": 34422,
	"./surf.png": 52022,
	"./tobiFun.png": 19667,
	"./tokenPocket.png": 95913,
	"./ton.png": 50863,
	"./tron.png": 25695,
	"./tronLink.png": 92719,
	"./trust.png": 26666,
	"./unisat.png": 42388,
	"./wallet.binance.com.png": 43404,
	"./walletConnect.png": 53363,
	"./xverse.png": 88229,
	"./zerion.png": 13957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38045;